import cc from 'classcat'

const CssUtil = {
  setTheme(theme) {
    this.theme = theme
  },
  classNames(styles, className) {
    return cc([styles[className], styles[`${this.theme}-${className}`] || ''])
  },
}

export default CssUtil
